<template>
  <div class="base">
    <div class="card-title">报修描述</div>
    <div class="card">
      <div class="card-cell">
        <div class="cell-title">
          <span class="required">*</span>
          <span>设备名称</span>
        </div>
        <div class="cell-content">{{ dataObj.title }}</div>
      </div>
      <div class="card-cell">
        <div class="cell-title">
          <span class="required">*</span>
          <span>报修位置</span>
        </div>
        <div class="cell-content">{{ dataObj.position }}</div>
      </div>
      <div class="card-cell textarea-cell">
        <div class="cell-title">
          <span class="required">*</span>
          <span>详情描述</span>
        </div>
        <div class="cell-content">{{ dataObj.details }}</div>
      </div>
      <div class="card-cell">
        <div class="cell-title">
          <span class="required">*</span>
          <span>报修联系人</span>
        </div>
        <div class="cell-content">{{ dataObj.contacts }}</div>
      </div>
      <div class="card-cell">
        <div class="cell-title">
          <span class="required">*</span>
          <span>联系电话</span>
        </div>
        <div class="cell-content">{{ dataObj.contactsMobile }}</div>
      </div>
    </div>
    <div class="card-title">现场照片</div>
    <div class="card">
      <div class="card-cell imgs-cell" v-if="fileList.length > 0">
        <img class="up-img" v-for="(item, index) in fileList" :key="index" :src="item" @click="showImg(item)" />
      </div>
      <div class="card-cell imgs-cell" v-if="fileList.length == 0">
        <div class="no-img">未上传现场照片</div>
      </div>
    </div>
    <!--    如果已经完成维修-->
    <template v-if="dataObj.repairStatus == '1'">
      <div class="card-title">报修处理</div>
      <div class="card">
        <div class="card-cell textarea-cell">
          <div class="cell-title">
            <span class="required">*</span>
            <span>维修描述</span>
          </div>
          <div class="cell-content">{{ dataObj.handleExplain }}</div>
        </div>
        <div class="imgs-cell-title">
          <span class="required">*</span>
          <span>维修照片</span>
        </div>
        <div class="card-cell imgs-cell" v-if="handleImagePath.length > 0">
          <img
            class="up-img"
            v-for="(item, index) in handleImagePath"
            :key="index"
            :src="item"
            @click="showImg(item)"
          />
        </div>
        <div class="card-cell imgs-cell" v-if="handleImagePath.length == 0">
          <div class="no-img">未上传维修照片</div>
        </div>
        <div class="card-cell">
          <div class="cell-title">
            <span class="required">*</span>
            <span>是否使用配件</span>
          </div>
          <div class="cell-content">
            <span v-if="dataObj.isParts == 0">否</span> <span v-if="dataObj.isParts == 1">是</span>
          </div>
        </div>
        <div class="card-cell" v-if="dataObj.isParts == 1">
          <div class="cell-title">
            <span class="required">*</span>
            <span>使用配件</span>
          </div>
          <div class="cell-content">{{ dataObj.consumables }}</div>
        </div>
        <div class="card-cell">
          <div class="cell-title">
            <span class="required">*</span>
            <span>完成时间</span>
          </div>
          <div class="cell-content">{{ dataObj.updateTime }}</div>
        </div>
      </div>
      <div class="footer"></div>
    </template>
    <mt-popup v-model="showImgFlag">
      <img :src="tempImgUrl" class="big-img" />
    </mt-popup>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg'
import { Indicator } from 'mint-ui'
import { getRepairData } from '@/api/enterprise'

export default {
  components: { UploadImg },
  data() {
    return {
      id: '',
      submiting: true,
      fileList: [],
      handleImagePath: [],
      dataObj: {},
      showImgFlag: false,
      tempImgUrl: ''
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getDetail()
  },
  methods: {
    getDetail() {
      const that = this
      Indicator.open('请稍等...')
      getRepairData({ id: that.id })
        .then((res) => {
          that.dataObj = res.result
          if (res.result.imagePath) {
            that.fileList = res.result.imagePath.split(',')
          }
          if (res.result.handleImagePath) {
            that.handleImagePath = res.result.handleImagePath.split(',')
          }
        })
        .catch((err) => {
          that.requestFailed(err)
        })
        .finally(() => {
          Indicator.close()
        })
    },
    showImg(item) {
      this.showImgFlag = true
      this.tempImgUrl = item
    }
  }
}
</script>

<style lang="less" scoped>
.base {
  background: #f7f8fc;
  min-height: 100vh;
  font-weight: 'Source Han Sans CN';

  .card-title {
    font-weight: 400;
    font-size: 15px;
    color: #999999;
    padding: 0px 20px;
    height: 55px;
    line-height: 55px;
  }

  .card {
    background: #ffffff;
    padding: 0px 20px;
    box-shadow: 0px 0px 2px 0px rgba(23, 140, 249, 0.1);

    &-cell {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f7f8fc;

      .cell-title {
        height: 50px;
        line-height: 50px;
      }

      .required {
        color: red;
      }

      .cell-content {
        width: 220px;
        font-size: 14px;
        line-height: 30px;
        text-align: right;
        display: -webkit-box;
        -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 2;
      }
    }

    .textarea-cell {
      flex-direction: column;
      align-items: flex-start;

      .cell-content {
        width: 100%;
        min-height: 149px;
        text-align: left;
        -webkit-line-clamp: 3;
        background: rgba(242, 242, 242, 0.8);
        border-radius: 10px;
        padding: 5px 10px;
        line-height: 35px;
      }
    }

    .imgs-cell-title {
      height: 50px;
      line-height: 50px;
      margin-bottom: -20px;

      .required {
        color: red;
      }
    }

    .imgs-cell {
      justify-content: flex-start;

      .up-img {
        margin: 20px 17.5px 20px 0px;
        width: 100px;
        height: 100px;
      }

      .no-img {
        color: #999999;
        line-height: 50px;
        height: 50px;
      }
    }
  }
}

.big-img {
  width: 375px;
}
</style>
